<template>
  <table-list
      ref="list"
      @query="handleLoadList"
      v-bind="$attrs"
      :request-params="{userNum: $route.query.num}"
      :data="tableData">
    <el-table-column align="center" :label="$t('品牌')" prop="name" />
    <el-table-column align="center" :label="$t('硬件ID号')" prop="deviceId" />
  </table-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
export default {
  name: "DeviceMange",
  components: {TableList},
  props: {
    tabCurrent: {
      type: String,
      default: ""
    },
    current: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  methods:  {
    async handleLoadList(params, setTotal) {
      try {
        console.log('调用')
        let res = await request(this.$api.linkHardwareRecord.listUser, params);
        for (const key in res) {
          if(Array.isArray(res[key])) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager.itemCount);
      }catch(e) {
        console.log(e);
      }
    }
  },
  watch: {
    current: {
      handler(val) {
        if(val === this.tabCurrent) {
          this.$nextTick(() => {
            this.$refs.list.handleRequest();
          })
        }
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>

</style>
